import * as React from "react";

function SvgTatari(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      {...{ ...props, ref }}
    >
      <rect x="0" y="2" width="22" height="8" fill="currentColor" />
      <rect x="6" y="12" width="14" height="8" fill="currentColor" />
      <rect x="0" y="22" width="8" height="8" fill="currentColor" />
    </svg>
  );
}

export default React.forwardRef(SvgTatari);
